// extracted by mini-css-extract-plugin
module.exports = {"sidebarSize":"Sidebar_sidebarSize__3y7k_"};